export const isMobileDevice = () => {
    const currentWidth = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;

    return 1180 > currentWidth;
}

